// Validación de TLD contra la lista oficial de IANA (tlds.data.ts, embebida).
// Es la capa CLIENTE del pipeline anti-typo: corta ".con"/".comm"/".cmo" al
// instante y sin consumir el chequeo MX del backend. Un TLD válido NO implica
// dominio válido (gmail.com.ar tiene TLD válido y no existe) — eso lo resuelve
// el MX check server-side.

import { TLD_SET } from './tlds.data';

/**
 * Si la terminación del dominio no es un TLD delegado por IANA, la devuelve
 * (ej: "con"); si es válida o no se puede evaluar, null.
 *
 * Fail-open deliberado: TLDs no-ASCII (IDN sin punycodear, ej ".рф") no se
 * evalúan acá — pasan al chequeo MX del backend, que es la fuente de verdad.
 */
export function unknownTld(domain: string): string | null {
  const normalized = domain.trim().toLowerCase().replace(/\.$/, '');
  const lastDot = normalized.lastIndexOf('.');
  if (lastDot < 0) return null; // sin punto: lo ataja la validación de formato
  const tld = normalized.slice(lastDot + 1);
  if (!tld || !/^[a-z0-9-]+$/.test(tld)) return null;
  return TLD_SET.has(tld) ? null : tld;
}
